exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delimiter--1szV5 {\n\tpadding: 5px 0 20px;\n}\n\n\t.delimiter--1szV5 .inner--1QKgy {\n\t\theight: 1px;\n\t\tbackground-color: #444;\n\t\twidth: 100%;\n\t}", ""]);

// Exports
exports.locals = {
	"delimiter": "delimiter--1szV5",
	"inner": "inner--1QKgy"
};